import { SERVER_URL } from "./config";

const groupNames = ["group-1"];

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

const biltyStatementDataObject = {
  paid_statement_no: "",
  bilty_info_list: [],
  input_date: formatDate(new Date()),
  amount_list: [],
  removed_bilty_ids: [],
  created_from: "",
  created_by: "",
  total_amount:"",
  inwarded: "",
  id: "",
};

const biltyStatementGroupInfo = {
  "group-1": [
    {
      label: "Bilty Count",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "bilty_count",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getItemSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "item_id",
      suggestionKeywordExtra: "description",
      url: SERVER_URL + "/item/",
      suggestionKeyword: "name",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "no_of_articles",
      },
      toValidate: false,
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        name: "name",
        desc: "description",
        item_id: "item_id",
      },
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "No Of Articles",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "no_of_articles",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getItemSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "item_id",
      suggestionKeywordExtra: "description",
      url: SERVER_URL + "/item/",
      suggestionKeyword: "name",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "weight",
      },
      toValidate: false,
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        name: "name",
        desc: "description",
        item_id: "item_id",
      },
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "weight",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getItemSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "item_id",
      suggestionKeywordExtra: "description",
      url: SERVER_URL + "/item/",
      suggestionKeyword: "name",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "freight",
      },
      toValidate: false,
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        name: "name",
        desc: "description",
        item_id: "item_id",
      },
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "PF",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pf",
      type: "text",
    },
    {
      label: "Total Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getItemSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "item_id",
      suggestionKeywordExtra: "description",
      url: SERVER_URL + "/item/",
      suggestionKeyword: "name",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
      toValidate: false,
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        name: "name",
        desc: "description",
        item_id: "item_id",
      },
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
  ],
};

function biltyStatementValidate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < biltyStatementGroupInfo[group_name].length; i++) {
      let field_object = biltyStatementGroupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const biltyStatementTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "User", className: "text-center table-header" },
  { label: "Amount", className: "text-center table-header" },
];

const biltyStatementTableItems = [
  {
    type: "text",
    name: "user",
    label: "User",
    className: "form-control-big-col",
  },
  {
    type: "text",
    name: "amount",
    label: "Amount",
    className: "form-control-large-col",
  },
];

const nrabChallanBiltyTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Destination", className: "text-center table-header" },
  { label: "Amount", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  { label: "Halami", className: "text-center table-header" },
  { label: "DD Charge", className: "text-center table-header" },
];

const defaultChallanBiltyTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Docket No.", className: "text-center table-header" },
  { label: "Docket Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Destination", className: "text-center table-header" },
  { label: "Amount", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  { label: "Charge Weight", className: "text-center table-header" },
  { label: "Private Marka No", className: "text-center table-header" },
];

const getChallanBiltyTableHeaderBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "nrab"){
    return nrabChallanBiltyTableHeader
  }
  else {
    return defaultChallanBiltyTableHeader
  }
}

var challanBiltyTableHeader = getChallanBiltyTableHeaderBasedOnClient()


const nrabChallanBiltyTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "destination_name",
    label: "Destination",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Amount",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "hamali",
    label: "Hamali",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "door_del_charge",
    label: "DD Charge",
    className: "form-control-large-col",
  },
];

const defaultChallanBiltyTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Docket No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Docket Date",
    className: "form-control-medium-col",
    // convertFunction: (itemObject)=>{
    //   return formatDate(itemObject.created_date)
    // }
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "destination_name",
    label: "Destination",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Amount",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Private Marka No",
    className: "form-control-large-col",
  },
];

const getChallanBiltyTableItemsBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "nrab"){
    return nrabChallanBiltyTableItems
  }
  else {
    return defaultChallanBiltyTableItems
  }
}

var challanBiltyTableItems = getChallanBiltyTableItemsBasedOnClient()
// const biltyValidations =  {
//   bilty_id: yup.number({"bilty_id": "Bilty should be string"}),
// }
export {
  groupNames,
  biltyStatementGroupInfo,
  biltyStatementDataObject,
  biltyStatementValidate,
  biltyStatementTableHeader,
  biltyStatementTableItems,
  challanBiltyTableItems,
  challanBiltyTableHeader,
};
